<template>
  <div class="consolidated-shipment-details">
    <ProposedShipmentLocationSection
      :id="`${uid}-locations`"
      v-model:shipment="internalProposedShipment"
    />

    <LineItemSection
      :id="`${uid}-line-items`"
      :model-value="lineItems"
      :editable="false"
      show-stops
    />
  </div>
</template>

<script lang="ts" setup>
import isEqual from 'lodash/isEqual';
import { computed, provide, toRefs } from 'vue';

import { useUid } from '@rygen/rygen-ui/composables';

import { ConsolidatedShipment } from '@/model/consolidation';

import LineItemSection from '@/components/lineItem/LineItemSection.vue';
import ProposedShipmentLocationSection from '@/components/multistop/ProposedShipmentLocationSection.vue';

const props = defineProps({
  proposedShipment: {
    type: ConsolidatedShipment,
    default: () => new ConsolidatedShipment(),
  },
});
const { proposedShipment } = toRefs(props);

const emit = defineEmits<{
  (event: 'update:proposed-shipment', shipment: ConsolidatedShipment): void;
}>();

const { uid } = useUid('consolidated-shipment-details');

const internalProposedShipment = computed({
  get() {
    return proposedShipment.value;
  },
  set(updatedShipment: ConsolidatedShipment) {
    if (!isEqual(updatedShipment, proposedShipment.value)) {
      emit('update:proposed-shipment', updatedShipment);
    }
  },
});

const lineItems = computed(() => {
  return proposedShipment.value.lineItems;
});

const stops = computed(() => {
  return proposedShipment.value.stops;
});

provide('shipmentStops', stops);
</script>
